import templateUrl from "./news-list.html";

export const newsListComponent = {
  bindings: {
    tags: "<",
    details: "<",
    categories: "<",
  },
  templateUrl,

  controller: class NewsListComponent {
    constructor($state, toastr, NewsService, ModalService) {
      "ngInject";
      this.$state = $state;
      this.toastr = toastr;
      this.NewsService = NewsService;
      this.modalService = ModalService;
    }

    $onInit() {
      this.sortBy = null;
      this.sortOrder = null;
      this.currentPage = 1;
      this.itemPerPage = 10;
      this.newsTagId = null;
      this.searchKeyword = "";
      this.newsCategoryId = null;
      this.totalItems = this.details.count;
      this.totalItemsPerPageCount = this.details.data.length;
    }

    onColumnClick(data, fieldName) {
      if (fieldName === "link") {
        window.open(data.link, "_blank");
      }
    }

    onView(data) {
      window.open(data.link, "_blank");
    }

    onEdit(data) {
      this.$state.go("newsEdit", { id: data.newsId });
    }

    onDelete(data) {
      const bodyMsg = "Are you sure to delete this news?";
      this.modalService.open({
        details: {
          bodyMessage: bodyMsg,
        },
        buttons: [
          {
            name: "No",
            action() {},
          },
          {
            name: "Yes",
            isPrimary: true,
            action: _onDelete.bind(this, data),
          },
        ],
      });
      function _onDelete(data) {
        this.NewsService.deleteNews(data.newsId)
          .then((_) => {
            this.toastr.success("News deleted successfully!!");
            this.$state.reload();
          })
          .catch((err) => {
            this.toastr.error(err);
          });
      }
    }

    onReset() {
      const params = {
        newsTagId: null,
        newsCategoryId: null,
      };
      this.newsTagId = params.newsTagId;
      this.newsCategoryId = params.newsCategoryId;
      this.$state.reload();
      return this.getUrlParams(params);
    }

    getUrlParams(value) {
      const defaultParams = {
        sortBy: this.sortBy,
        pageId: this.currentPage,
        sortOrder: this.sortOrder,
        newsTagId: this.newsTagId,
        searchKeyword: this.searchKeyword,
        newsCategoryId: this.newsCategoryId,
      };
      Object.keys(defaultParams).map((key) => {
        if (value.hasOwnProperty(key)) {
          defaultParams[key] = value[key];
        }
      });
      return this.NewsService.getNewsListByParams(defaultParams).then(
        (details) => {
          this.details = details;
          this.totalItemsPerPageCount = details.data.length;
        }
      );
    }

    onChangeCategory() {
      return this.getUrlParams({ newsCategoryId: this.newsCategoryId });
    }

    onChangeTag() {
      return this.getUrlParams({ newsTagId: this.newsTagId });
    }

    onChangePage(pageNumber) {
      this.currentPage = pageNumber;
      const count = this.details.count;
      return this.getUrlParams({ pageId: pageNumber }).then(() => {
        this.details.count = count;
      });
    }

    onSearch() {
      this.currentPage = 1;
      this.sortBy = null;
      this.sortOrder = null;
      return this.getUrlParams({ pageId: null });
    }

    clearSearch() {
      this.searchKeyword = "";
      return this.onSearch();
    }

    onColumnSort(fieldName, sortOrder) {
      this.sortBy = fieldName;
      this.sortOrder = sortOrder;
      this.currentPage = 1;
      return this.getUrlParams({ sortBy: fieldName, sortOrder, pageId: null });
    }
  },
};



// WEBPACK FOOTER //
// ./src/app/components/news/news-list/news-list.component.js